import { Link } from "react-router-dom";

const LOGO = "/sito/img/logo.png";

export function SiteFooter({ contacts, desc }) {
  const c = contacts || {};
  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="container footer-grid">
        <div>
          <img src={LOGO} className="logo-img logo-white" alt="POWERCOM" />
          <p className="footer-desc">{desc}</p>
        </div>
        <div>
          <h4>Menu</h4>
          <Link to="/">Home</Link>
          <Link to="/chi-siamo">Chi Siamo</Link>
          <Link to="/servizi">I Nostri Servizi</Link>
          <Link to="/portfolio">Portfolio</Link>
          <Link to="/lavora-con-noi">Lavora con noi</Link>
          <Link to="/contatti">Contatti</Link>
        </div>
        <div>
          <h4>Contatti</h4>
          {c.company && <p style={{ fontWeight: 700, color: "#fff" }}>{c.company}</p>}
          <p>{c.address}</p>
          <p>{c.phone}</p>
          <p>{c.email}</p>
          {c.vat && <p>P.IVA {c.vat}</p>}
        </div>
      </div>
      <div className="container footer-bottom">
        <p>© 2026 POWERCOM. Tutti i diritti riservati.</p>
        <Link to="/admin" className="admin-link" data-testid="footer-admin-link">Area riservata</Link>
      </div>
    </footer>
  );
}
